var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { lazy, useEffect, useRef } from "react";
import { ConfigProvider } from "@travel/shared/data-access/use-config/use-config";
import { ViewportProvider } from "@travel/shared/hooks/use-viewport/use-viewport";
import { PortalQuerySelector } from "./utils";
import { parseDate } from "@travel/shared/utils/dates";
import { OverlayProvider } from "@travel/shared/ui/overlays/overlay/overlay";
import { REFRESH_SDK } from "./types";
import pclnConfig from "./pcln-config.json";
import SDKCollection from "./features/collection";
var HostedUI = lazy(function () { return import("./features/hosted-ui/hosted-ui"); });
var HotelSearchForm = lazy(function () { return import("./features/hotel-search-feature/hotel-search-feature"); });
export default function SDK(_a) {
    var config = _a.config;
    var hotelSearchFormRef = useRef(null);
    useEffect(function () {
        /*getAnalytics().then(([analytics]) => {
          analytics.track("init", {
            partnerId: config.partnerID,
          });
        });*/
        window.TravelSDK[REFRESH_SDK] = function () {
            var _a;
            (_a = hotelSearchFormRef.current) === null || _a === void 0 ? void 0 : _a.refresh();
        };
        return function () {
            window.TravelSDK[REFRESH_SDK] = function () { };
        };
    }, []);
    return (_jsx(ViewportProvider, { children: _jsx(OverlayProvider, { children: _jsxs(ConfigProvider, { config: config, children: [_jsx(PortalQuerySelector, { selector: ".travel__hosted-ui", component: function () { return _jsx(HostedUI, { config: config }); } }), _jsx(PortalQuerySelector, { selector: ".travel__collection", component: function (_a) {
                            var carousel = _a.carousel, colSm = _a.colSm, colMd = _a.colMd, colLg = _a.colLg, colXl = _a.colXl, attributes = __rest(_a, ["carousel", "colSm", "colMd", "colLg", "colXl"]);
                            return (_jsx(SDKCollection, __assign({}, attributes, { isCarousel: !!carousel, columnsSmall: colSm || undefined, columnsMedium: colMd || undefined, columnsLarge: colLg || undefined, columnsExtraLarge: colXl || undefined })));
                        }, attributes: [
                            "data-travel-collection-id",
                            "data-travel-title",
                            "data-travel-subtitle",
                            "data-travel-affiliate",
                            "data-travel-campaign",
                            ["data-travel-show-title", parseBoolean],
                            ["data-travel-show-subtitle", parseBoolean],
                            ["data-travel-muted-heading", parseBoolean],
                            ["data-travel-show-place-names", parseBoolean],
                            ["data-travel-show-carousel", parseBoolean],
                            ["data-travel-show-dates", parseBoolean],
                            ["data-travel-show-more", parseBoolean],
                            ["data-travel-carousel", parseBoolean],
                            ["data-travel-col-sm", parseNumber],
                            ["data-travel-col-md", parseNumber],
                            ["data-travel-col-lg", parseNumber],
                            ["data-travel-col-xl", parseNumber],
                        ] }), _jsx(PortalQuerySelector, { selector: ".travel__hotel-search-form", component: function (_a) {
                            var _b;
                            var displayPcln = _a.displayPcln, displayVertical = _a.displayVertical, attributes = __rest(_a, ["displayPcln", "displayVertical"]);
                            return (_jsx(HotelSearchForm, __assign({}, attributes, { domain: config.domain, logo: displayPcln ? undefined : (_b = config === null || config === void 0 ? void 0 : config.assets) === null || _b === void 0 ? void 0 : _b.logo, logoURL: (displayPcln ? pclnConfig : config).homepage, companyName: config.companyName, horizontal: !displayVertical })));
                        }, ref: hotelSearchFormRef, attributes: [
                            "data-travel-location-query",
                            "data-travel-location-id",
                            "data-travel-location-type",
                            "data-travel-affiliate",
                            "data-travel-campaign",
                            "data-travel-submit-theme",
                            ["data-travel-check-in", parseDate],
                            ["data-travel-check-out", parseDate],
                            ["data-travel-room-count", parseNumber],
                            ["data-travel-adult-count", parseNumber],
                            ["data-travel-show-logo", parseBoolean],
                            ["data-travel-show-title", parseBoolean],
                            ["data-travel-show-logo-powered-by", parseBoolean, true],
                            ["data-travel-display-card", parseBoolean],
                            ["data-travel-display-pcln", parseBoolean],
                            ["data-travel-display-vertical", parseBoolean],
                            ["data-travel-navigate-pcln", parseBoolean],
                        ], mutateNode: themeOverride })] }) }) }));
}
function themeOverride(node, _a) {
    var displayPcln = _a.displayPcln;
    if (displayPcln) {
        for (var prop in pclnConfig.theme) {
            node.style.setProperty("--travel-".concat(prop), pclnConfig.theme[prop]);
            node.style.setProperty("--travel-theme-".concat(prop), pclnConfig.theme[prop]);
        }
    }
}
function parseBoolean(bool) {
    return bool === "true" ? true : false;
}
function parseNumber(count) {
    return Number(count);
}
